import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import Avatar from '../avatar/Avatar';
import { getCreatedByText, getUserInitials } from '../../utils/stringHandling';
import { useEffect, useState } from 'react';
import UserService from '../../services/UserService';
import { ProfileDTO2, ProfileDTO2Role } from '../../api/api';
import CircularProgress from '../circular-progress/CircularProgress';
import { log } from '../../utils/logging/log';

export interface Contact {
  email?: string;
}

const ContactCard = (props: Contact) => {
  const { email } = props;

  const [user, setUser] = useState<ProfileDTO2>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!email) return;
    setIsLoading(true);
    UserService.getUserByEmail(email)
      .then((_user) => {
        setUser(_user);
      })
      .catch((e) => {
        log(e);
      })
      .finally(() => setIsLoading(false));
  }, [email]);

  return (
    <ContactContainer>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <ContentContainer>
          <TopContainer>
            <Avatar fontSize={14} size={30} text={getUserInitials(user?.name)} />
            <FullName variant="h6" fontWeight="bold">
              {getCreatedByText(user?.name, email)}
            </FullName>
          </TopContainer>
          <ContactInformation fontWeight="bold" variant="subtitle1">
            Kontaktoplysninger
          </ContactInformation>
          <InfoContainer>
            <Info widthPercentage={60}>
              <Label>Fulde navn</Label>
              <Value fontWeight="bold">{user?.name ?? '-'}</Value>
            </Info>
            <Info widthPercentage={40}>
              <Label>Telefonnummer</Label>
              <Value fontWeight="bold">{user?.phone ?? '-'}</Value>
            </Info>
            {user?.role !== ProfileDTO2Role.Technician && (
              <Info>
                <Label>Afdeling</Label>
                <Value fontWeight="bold">{user?.department?.name ?? '-'}</Value>
              </Info>
            )}
          </InfoContainer>
        </ContentContainer>
      )}
    </ContactContainer>
  );
};

const ContactContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${(props) => props.theme.spacing(10)};
  border-radius: 150px;
`;

const TopContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FullName = styled(Typography)`
  padding-left: ${(props) => props.theme.spacing(2.5)};
`;

const ContactInformation = styled(Typography)`
  padding-top: ${(props) => props.theme.spacing(5)};
  flex-wrap: wrap;
`;

const Info = styled.div<{ widthPercentage?: number }>`
  margin-top: ${(props) => props.theme.spacing(3)};
  width: ${(props) => props.widthPercentage}%;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${(props) => props.theme.spacing(2.5)};
`;

const Label = styled(Typography)`
  color: ${(props) => props.theme.palette.grey.black60};
`;

const Value = styled(Typography)`
  color: black;
  margin-top: ${(props) => props.theme.spacing(1)};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export default ContactCard;
